var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import React from "react";
export function useUnload(fn) {
  return __async(this, null, function* () {
    const cb = React.useRef(fn);
    React.useEffect(() => {
      const onUnload = cb.current;
      window.addEventListener("beforeunload", onUnload);
      return () => {
        window.removeEventListener("beforeunload", onUnload);
      };
    }, [cb]);
  });
}
export function profileHeaderToken(token) {
  return {ProfileAuthorization: `Bearer ${token}`};
}
export const getCallEmailText = (email) => `Please note that you will receive call notifications to <a href="mailto:${email}">${email}</a>.`;
